export enum QuestionType {
  Single_Select = 'SINGLE_SELECT',
  Text = 'TEXT',
}
